var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "accordion" }, [
    _c(
      "button",
      {
        staticClass: "accordion__header",
        class: _vm.headerClass,
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.activate.apply(null, arguments)
          }
        }
      },
      [
        _c("span", {
          staticClass: "h4",
          domProps: { innerHTML: _vm._s(_vm.heading) }
        }),
        _c("icon", { attrs: { name: _vm.currentIcon, size: "24px" } })
      ],
      1
    ),
    _vm.active
      ? _c(
          "div",
          {
            ref: "content",
            staticClass: "accordion__content",
            attrs: { transition: "expand" }
          },
          [
            _c(
              "div",
              { staticClass: "accordion__inner-content" },
              [_vm._t("default")],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }